import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { Button, Typography } from '@raisin/components-lib';

export const Container = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(8),
  padding: theme.spacing(6),
  margin: theme.spacing(6),

  '[role="tabpanel"] > .MuiBox-root': {
    padding: 0,
  },

  [theme.breakpoints.down('sm')]: {
    padding: 0,
  },
}));

export const InputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(6),
  borderRadius: 16,
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    flexFlow: 'wrap',
  },
}));

export const InputWrapper = styled('div')(({ theme }) => ({
  width: 284,
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const MultiSelectWrapper = styled('div')(({ theme }) => ({
  width: 492,
  paddingTop: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const HeadingsRowContainer = styled(Box)(({ theme, $isSavingsOffer }) => ({
  display: 'grid',
  gridTemplateColumns: `2fr repeat(${$isSavingsOffer ? 4 : 5}, 1fr)`,
  padding: theme.spacing(6),

  ...(!$isSavingsOffer && {
    div: {
      gridColumnStart: 5,
      gridColumnEnd: 7,
    },
  }),
}));

export const BankLogoContainer = styled(Box)(({ theme, $flex }) => ({
  display: 'inline-flex',
  flex: $flex,
  width: 48,
  height: 48,
  position: 'relative',
  marginRight: theme.spacing(6),

  [theme.breakpoints.down('sm')]: {
    marginRight: 0,
  },
}));

export const BankLogo = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
}));

export const PlainColumnText = styled(Typography)(({ theme }) => ({
  cursor: 'default',
  color: theme.palette.black60.main,
  display: 'inline-flex',
  alignItems: 'center',
}));

export const SortableColumnText = styled(Typography)(({ theme }) => ({
  color: theme.palette.black60.main,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
}));

export const Text = styled(Typography)(({ theme, $color, $flex }) => ({
  flex: $flex,
  color: $color ? theme.palette?.[$color].main : theme.palette.black100.main,
}));

export const BlueText = styled(Text)(({ theme }) => ({
  color: theme.palette.blue60.main,
}));

export const Footer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: theme.spacing(6),
}));

export const LoadMoreButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const Disclaimer = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(6),
}));

export const TooltipButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  color: theme.palette.black60.main,

  '&:hover': {
    backgroundColor: 'transparent',
  },
}));
